import { Card, Page, EmptyState as ShopifyEmptyState } from '@shopify/polaris'
import { useTranslation } from 'react-i18next'
import MainLayout from '../shared/layouts/MainLayout'
import { useNavigate } from 'react-router'
import { PAGE_ENUM } from '@Types/Enums'
import { useContents } from '@Utils/EmptyStateContents'
import { useOnboardingActions } from '@Store/slices/onboarding'
import { useEffect } from 'react'

type EmptyStateProps = {
  path: string
} & React.ComponentProps<typeof Page>

function EmptyState({ path }: EmptyStateProps): JSX.Element {
  const { setOnboardingCanceled, setFirstRunLogin, setMenuItemClicked } =
    useOnboardingActions()
  const { t: translate } = useTranslation()
  const contents = useContents()
  const navigate = useNavigate()

  const firstSegment = path.split('/')[1]?.toLowerCase() as
    | PAGE_ENUM
    | undefined
  const page =
    firstSegment && firstSegment in contents ? firstSegment : PAGE_ENUM.OVERVIEW

  useEffect(() => {
    setOnboardingCanceled(false)
    setFirstRunLogin(false)
  }, [])

  return (
    (Object.keys(contents).length > 0 && (
      <MainLayout title={translate(`Prisync.${page}.label`)}>
        <Card roundedAbove="sm">
          <ShopifyEmptyState
            heading={contents[page].title}
            action={{
              content: 'Continue Onboarding',
              onAction() {
                setMenuItemClicked('/onboarding')
                navigate('/onboarding')
              },
            }}
            image={contents[page].image}
          >
            <p>{contents[page].description}</p>
          </ShopifyEmptyState>
        </Card>
      </MainLayout>
    )) || <></>
  )
}

export default EmptyState
